var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-table-action-button',{attrs:{"url":_vm.url,"label":_vm.trans('buttons.update'),"grid":_vm.grid}},[_c('inline-svg',{attrs:{"url":require('../../../../images/actions/edit.svg'),"classes":"table-action-cell__icon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }